export enum ProducerRole {
  Admin = 0,
  Producer = 1,
  ViewOnly = 2
}

export interface ProducerRoleInfo {
  role: string;
  assignedByProducerId: number;
  assignedByProducerName: string;
}

export interface ProducerResponse {
  id: number;
  catalogUserId: number;
  tenantId: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  lastLoginDate?: string;
  roles: ProducerRoleInfo[];
  companyName?: string;
}

export interface CreateProducerRequest {
  email: string;
  firstName?: string;
  lastName?: string;
  initialRole: ProducerRole;
}

export interface CreateProducerResponse {
  producerId: number;
  email: string;
  firstName?: string;
  lastName?: string;
  message: string;
}

export interface RoleAssignmentResponse {
  id: number;
  producerId: number;
  producerName: string;
  role: ProducerRole;
  assignedByProducerId: number;
  assignedByProducerName: string;
  createdAt: string;
}

export interface ProducerDropdownOption {
  id: number | null;
  displayName: string;
}

export interface ProducerDropdownResponse {
  id: number;
  displayName: string;
}

// Sentinel value for "All Producers" option
export const ALL_PRODUCERS_ID = -1;

